export default __webpack_public_path__ + "static/media/billing.d909f976.svg";